import { createAPI } from '@common'
export default {
  // 编目添加字段
  postExtfields: (config) => createAPI('customEncryptApiName-1/0w20fyugjfmet', 'POST', config),
  // 编目修改字段
  putExtfields: (config) => createAPI('customEncryptApiName-1/0w20fyugjfmet', 'PUT', config),
  // 编目删除字段
  postExtfieldsDelete: (config) =>
    createAPI('customEncryptApiName-1/0w20fyugjfmet0efmfuf', 'POST', config),
  // 编目查询字段
  getExtfields: (config) => createAPI('customEncryptApiName-1/0w20fyugjfmet', 'GET', config)
}
